<template>
  <div class="activity">
    <item-booking-activities
      v-if="item"
      :bookingWorkspaceID="totemItemBookingWorkspaceID"
      :data="item"
      :filterType="filterType"
    />
  </div>
</template>
<script>
import tinycolor from 'tinycolor2'
import { mapState } from 'vuex'
import ItemBookingActivities from '@/views/public/mobile/customMenu/items/bookingActivities/Index'
export default {
  components: {
    ItemBookingActivities
  },
  props: {
    enterprise: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    item: null,
    filterType: null,
  }),
  computed: {
    ...mapState('app',['totemItemBookingWorkspaceID', 'totemItemBookingCategoryFilter', 'totemItemBookingCategoryFilter']),
  },
  watch: {
    'totemItemBookingCategoryFilter' (v) {
      this.filterType =  v && v.length > 0 ? v : null
    },
  },
  mounted () {
    const aux = this.$store.state.app.totemItemBookingCategoryFilter
    this.filterType =  aux && aux.length > 0 ? aux : null
    this.prepareConfig()
  },
  methods: {
    prepareConfig () {
      // by Ivan
      let aux = this.totemItemBookingWorkspaceID === '638616ce-b6df-478f-8546-f84abde50267' || this.totemItemBookingWorkspaceID === '879d9b61-c166-4fde-a3fc-5db53ce48a73' || this.totemItemBookingWorkspaceID === '73b92ad1-d8ce-4849-97c5-baae35ae4a20' || this.totemItemBookingWorkspaceID === 'f13389ff-fc1e-4712-b558-ce5299848a8f' ? this.enterprise.BGColorSecundary : this.enterprise.BGColor

      aux = tinycolor(aux).isLight() ? this.enterprise.BGColorSecundary : aux

      this.item = {
        BookingActTypeColor: this.enterprise.BGColorContent,
        BookingActContentColor: this.enterprise.ColorContent,
        BookingActTimeColor: this.enterprise.BGColorSecundary,
        BookingActTitleColor: aux,
        //BookingActTitleColor: this.totemItemBookingWorkspaceID === '638616ce-b6df-478f-8546-f84abde50267' || this.totemItemBookingWorkspaceID === '879d9b61-c166-4fde-a3fc-5db53ce48a73' || this.totemItemBookingWorkspaceID === '73b92ad1-d8ce-4849-97c5-baae35ae4a20' || this.totemItemBookingWorkspaceID === 'f13389ff-fc1e-4712-b558-ce5299848a8f' ? this.enterprise.BGColorSecundary : this.enterprise.BGColor,
        BookingActWeekPrimaryColor: this.enterprise.BGColor,
        BookingActWeekSecondaryColor: this.enterprise.BGColorSecundary,
      }
    },
  },
}
</script>
<style scope>
.activity {
  height: 100%;
  overflow-y: scroll;
}
</style>
